import React, { useEffect, useState } from "react";
import MainDashboardLayout from "../../../Layout/MainDashboardLayout";
import GRISidebar from "../../../Layout/GRISidebar";
import styles from "../../../styles/gri/general.module.css";
import InputField from "../../../Components/Masters/InputField";
import { Box, Button } from "@mui/material";
import EastIcon from "@mui/icons-material/East";
import { get, put } from "../../../utils/api";
import { useNavigate, useParams } from "react-router-dom";
import MessagePopup from "../../../Components/Masters/MessagePopup";
import ReviewBox from "../../../Components/Common/ReviewBox";
import { currentYear } from "../../../utils/generateYearRanges";

const GeneralDisclosure228 = ({hide}) => {
  const [data, setData] = useState({});
  const [griReview, setGriReview] = useState(() => JSON.parse(localStorage.getItem("griReview")));

  const { id } = useParams();
  const [disabled, setDisabled] = useState(false);
  const [formData, setFormData] = useState("");
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [errors, setErrors] = useState();
  const navigate = useNavigate();

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const res = await get(`/gri/get?Id=${id}&type=GeneralDisclosures2021`);
      const res1 = res.data.data.GeneralDisclosures2021.membershipAssociations;
      if (res?.data?.data?.year ? res?.data?.data?.year < currentYear -1 : false) setDisabled(true);
      setData(res1);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    setFormData(data || "");
  }, [data]);

  const handleSubmit = async () => {
    if (!disabled) {
      let transformedData2 = {
        membershipAssociations: formData,
        type: "GeneralDisclosures2021",
        submitted2_28: true,
      };
      try {
        const res = await put(`/gri/update?Id=${id}`, transformedData2);
        setsnackOpen({
          open: true,
          message: res?.data?.message,
          severity: "success",
        });
        navigate(`/gri/general-disclosure/2-29/${id}`);
      } catch (error) {
        console.log(error?.response?.data?.message);
        setsnackOpen({
          open: true,
          message: error?.response?.data?.message,
          severity: "error",
        });
      }
    } else {
      navigate(`/gri/general-disclosure/2-29/${id}`);
    }
  };

  const renderContent = ({hide}) => (
    <>
      <MessagePopup {...{ snackOpen, setsnackOpen }} />{" "}
      <p className={styles.main_heading}>2-28 Membership associations</p>
      {/* a */}
      <p
        className={styles.ques_heading}
        style={{ textIndent: "-1rem", marginTop: hide ? "-1.5rem" : "2.5rem", marginBottom: hide ? "-1rem" : "0rem" }}
      >
        a. Please disclose the industry associations, other membership
        associations, and national or international advocacy organizations in
        which the organization plays a significant role. This could include
        board memberships, active participation in committees or working groups,
        or other substantial involvement.
      </p>
      <Box sx={{ ml: 2,mt:3 ,}}>
        <InputField
          placeholder={"Enter Text"}
          value={formData}
          mt="-5px"
          handleChange={(e) => {
            setFormData(e.target.value);
            setErrors("");
          }}
          errors={errors && true}
          disabled={disabled}
        />
        <p
          color="error"
          variant="caption"
          style={{
            lineHeight: "1.2",
            margin: "2px 0",
            marginTop: "5px",
            color: "#d34040",
            fontSize: "10px",
            fontStyle: "italic",
          }}
        >
          {errors}
        </p>
      </Box>
     
    </>
  )

  return (
    <>
      {!hide ? (
        <MainDashboardLayout sidebar={<GRISidebar />}>
          {renderContent({ hide })}

          <>
             {!griReview ? (
        <Box sx={{ ml: "1rem", width: "98%" }}>
          <ReviewBox url={"/gri"} handleSubmit={handleSubmit} />
        </Box>
      ) : (
        <Box textAlign="right" sx={{ mt: 3 }}>
          <Button
            onClick={handleSubmit}
            variant="contained"
            sx={{ bgcolor: "#1C486B", textTransform: "none", mt: 3, mb: 5 }}
          >
            Save & Continue <EastIcon sx={{ ml: 2 }} />
          </Button>
        </Box>
      )}
          </>
        </MainDashboardLayout>
      ) : (
        renderContent({ hide })
      )}
    </>
  );
};

export default GeneralDisclosure228;
